import { useScheduleBoardContext } from 'pos-client/components/scheduleBoard/context/ScheduleBoardContext.tsx';

export const useSelectedLocationCurrentDate = () => {
  const { selectedLocation } = useScheduleBoardContext();

  const selectedLocationTimeZone = selectedLocation?.address?.timeZone;

  const getCurrentDateInSelectedLocationTimeZone = () => {
    if (!selectedLocationTimeZone) return null;

    const currentDate = new Date();
    const options = {
      timeZone: selectedLocationTimeZone,
    };

    const timestamp = currentDate.toLocaleString('en-US', options);

    return new Date(timestamp);
  };

  const now = getCurrentDateInSelectedLocationTimeZone();

  return now;
};
